import { LinkProps } from '@/types';

export enum AccountMenuLinkKey {
  login = 'login',
}

export interface AccountMenuLink extends Omit<LinkProps, 'modalClass'> {
  key?: AccountMenuLinkKey | null;
}
